import styles from './Footer.module.scss';
import { useTranslation } from 'react-i18next';
import { VdsFooter } from '@volt/volt-extended-components-react';

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <VdsFooter appVersion={t('DigitalMine')} type="default" />
    </footer>
  );
}

export default Footer;
